// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "Dashboard") return "AM/js/chunks/" + chunkId + ".e53dcbdc.js";
	if (chunkId === "AM/js/common") return chunkId + ".51a22769.js";
	if (chunkId === "Products") return "AM/js/chunks/" + chunkId + ".e33be95b.js";
	if (chunkId === "SellersProducts") return "AM/js/chunks/" + chunkId + ".4516ff0f.js";
	if (chunkId === "ProductCategories") return "AM/js/chunks/" + chunkId + ".866be5af.js";
	if (chunkId === "ProductEdit") return "AM/js/chunks/" + chunkId + ".4b51d53e.js";
	if (chunkId === "ProductAttributes") return "AM/js/chunks/" + chunkId + ".c2ed03b1.js";
	if (chunkId === "Toolkits") return "AM/js/chunks/" + chunkId + ".13b83927.js";
	if (chunkId === "ToolkitVisualizer") return "AM/js/chunks/" + chunkId + ".8a259481.js";
	if (chunkId === "ToolkitCategories") return "AM/js/chunks/" + chunkId + ".28efe1ef.js";
	if (chunkId === "vendor-Chat") return "AM/js/chunks/" + chunkId + ".4f5414db.js";
	if (chunkId === "Chat") return "AM/js/chunks/Chat.381bd685.js";
	if (chunkId === "Users") return "AM/js/chunks/" + chunkId + ".da9624fc.js";
	if (chunkId === "UserEdit") return "AM/js/chunks/" + chunkId + ".4e5ed71a.js";
	if (chunkId === "Forbidden") return "AM/js/chunks/" + chunkId + ".68f98b0d.js";
	if (chunkId === "RestImport") return "AM/js/chunks/" + chunkId + ".54fec98d.js";
	if (chunkId === "Subscriptions") return "AM/js/chunks/" + chunkId + ".06001e31.js";
	if (chunkId === "SubscriptionSingle") return "AM/js/chunks/" + chunkId + ".d8ddd7b5.js";
	// return url for filenames based on template
	return undefined;
};